<template>
  <el-dialog
    :title="isEdit ? '编辑物业费信息' : '新增物业费信息'"
    :visible.sync="visible"
    width="900px"
    append-to-body
    close-on-click-modal="false"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="120px"
      class="fee-form"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="年度" prop="annual">
            <el-select v-model="form.annual" placeholder="请选择年度" style="width:100%">
              <el-option :label="y" :value="y" v-for="y in yearList" :key="y"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="区域" prop="area">
            <el-select v-model="form.area" placeholder="区域" style="width:100%">
              <el-option label="南区" value="南区"></el-option>
              <el-option label="北区" value="北区"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
         <el-form-item label="楼栋" prop="buildingNo">
            <el-input v-model="form.buildingNo" placeholder="楼栋"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="房间号" prop="roomNo">
            <el-input v-model="form.roomNo" placeholder="房间号"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="建筑面积(㎡)" prop="buildingArea">
            <el-input v-model="form.buildingArea"  placeholder="面积"  @input="filterDecimal" @change="computeFee"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="物业费单价(元/㎡)" prop="propertyFeeUnitPrice">
            <el-input v-model="form.propertyFeeUnitPrice" placeholder="单价" @input="filterDecimal" @change="computeFee"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="缴费方式" prop="propertyFeePayType">
            <el-select v-model="form.propertyFeePayType" placeholder="缴费方式" style="width:100%" @change="computeFee">
              <el-option label="按月缴费" value="按月缴费"></el-option>
              <el-option label="按季度缴费" value="按季度缴费"></el-option>
              <el-option label="按半年度缴费" value="按半年度缴费"></el-option>
              <el-option label="按年缴费" value="按年缴费"></el-option>
              <el-option label="一次性付清" value="一次性付清"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="承租人" prop="lessee">
            <el-input v-model="form.lessee" placeholder="承租人"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="开始时间">
            <el-date-picker v-model="form.leaseStartTime" type="date" placeholder="开始时间" style="width:100%" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="结束时间">
            <el-date-picker v-model="form.leaseEndTime" type="date" placeholder="结束时间" style="width:100%" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="应收金额(元)">
            <el-input v-model="form.propertyFeeAmount" @input="filterDecimal" placeholder="自动计算"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="已缴金额(元)" prop="paidPropertyFee">
            <el-input v-model="form.paidPropertyFee" @input="filterDecimal" placeholder="已缴金额" @change="computeDebt"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="欠费金额(元)">
            <el-input v-model="form.outstandingAmount" @input="filterDecimal" disabled placeholder="自动计算"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="装修押金(元)">
            <el-input v-model="form.decorationDeposit" @input="filterDecimal" placeholder="装修押金"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="垃圾清运费(元)">
            <el-input v-model ="form.decorationWasteRemovalFee" @input="filterDecimal" placeholder="清运费"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系人">
            <el-input v-model="form.contactPerson" placeholder="联系人"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="联系方式">
            <el-input v-model="form.contactInfo" placeholder="电话"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="物业费缴纳日期">
             <el-date-picker v-model="form.propertyFeePayDate" type="date" placeholder="物业费缴纳日期" style="width:100%" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注">
            <el-input v-model="form.remark" type="textarea" rows="3" placeholder="备注"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="submit">确认保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'PropertyManagementFeeDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {},
      yearList: [],
      rules: {
        area: [{ required: true, message: '请选择区域', trigger: 'change' }],
        buildingNo: [{ required: true, message: '请选择楼栋', trigger: 'change' }],
        roomNo: [{ required: true, message: '请输入房间号', trigger: 'blur' }],
        annual: [{ required: true, message: '请选择年度', trigger: 'change' }],
        buildingArea: [{ required: true, message: '请输入面积', trigger: 'blur' }],
        propertyFeeUnitPrice: [{ required: true, message: '请输入单价', trigger: 'blur' }],
        propertyFeePayType: [{ required: true, message: '请选择缴费方式', trigger: 'change' }]
      }
    }
  },
  watch: {
    formData: {
      handler(val) {
        this.form = JSON.parse(JSON.stringify(val));
        this.computeFee();
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    const currentYear = new Date().getFullYear();
    this.yearList = [currentYear - 1, currentYear, currentYear + 1];
  },
  methods: {
    computeFee() {
      const area = Number(this.form.buildingArea) || 0;
      const price = Number(this.form.propertyFeeUnitPrice) || 0;
      const monthAmount = area * price;
      let total = monthAmount;

      switch (this.form.propertyFeePayType) {
        case '按季度缴费':
          total = monthAmount * 3;
          break;
        case '按半年度缴费':
          total = monthAmount * 6;
          break;
        case '按年缴费':
          total = monthAmount * 12;
          break;
        case '一次性付清':
          total = monthAmount;
          break;
      }
      this.form.propertyFeeAmount = Math.round(total * 100) / 100;
      this.computeDebt();
    },
    computeDebt() {
      const total = Number(this.form.propertyFeeAmount) || 0;
      const paid = Number(this.form.paidPropertyFee) || 0;
      this.form.outstandingAmount = Math.max(0, total - paid);
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('save', this.form);
        } else {
          this.$message.error('请完善必填信息');
        }
      });
    },
    close() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.fee-form {
  padding: 10px 0;
}
.dialog-footer {
  text-align: right;
}
</style>